/* eslint-disable ember/no-classic-components */
import Component from "@ember/component";
import { computed } from "@ember/object";
import { tagName } from "@ember-decorators/component";
import { makeArray } from "discourse/lib/helpers";
import selectKitPropUtils from "discourse/select-kit/lib/select-kit-prop-utils";

@tagName("")
@selectKitPropUtils
export default class FormatSelectedContent extends Component {
  /** @type {unknown} */
  content = null;

  /** @type {import("discourse/select-kit/components/select-kit").SelectKitState | null} */
  selectKit = null;

  @computed("content")
  get formattedContent() {
    if (this.content) {
      return makeArray(this.content)
        .map((c) => this.getName(c)?.trim())
        .join(", ");
    } else {
      return this.getName(this.selectKit.noneItem);
    }
  }

  <template>
    <span class="formatted-selection">
      {{this.formattedContent}}
    </span>
  </template>
}
